window.sq = window.sq || {}; window.sq.filtervga = [
  {
    "id": "gid://shopify/Metaobject/96870891735",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Universal"
  },
  {
    "id": "gid://shopify/Metaobject/96872661207",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD Radeon RX 6800XT Nitro+ "
  },
  {
    "id": "gid://shopify/Metaobject/96873545943",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "GeForce® RTX 3080 and 3090(reference)"
  },
  {
    "id": "gid://shopify/Metaobject/96862044375",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "GeForce GTX 1080"
  },
  {
    "id": "gid://shopify/Metaobject/96865648855",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "NVIDIA GeForce RTX 2070/2080/2070 Super/2080 SUPER"
  },
  {
    "id": "gid://shopify/Metaobject/96879935703",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Nvidia Founders Edition RTX 4090"
  },
  {
    "id": "gid://shopify/Metaobject/96880787671",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Geforce RTX 40XX"
  },
  {
    "id": "gid://shopify/Metaobject/96867287255",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "NVIDIA GeForce RTX 2080/2080 SUPER"
  },
  {
    "id": "gid://shopify/Metaobject/96874102999",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "EVGA® XC3 RTX 3080 and 3090"
  },
  {
    "id": "gid://shopify/Metaobject/96868827351",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Older Nvidia"
  },
  {
    "id": "gid://shopify/Metaobject/96869122263",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD 7XXX"
  },
  {
    "id": "gid://shopify/Metaobject/96874234071",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": " EVGA RTX 3080/3090 FTW3"
  },
  {
    "id": "gid://shopify/Metaobject/96858243287",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Nvidia 4XX"
  },
  {
    "id": "gid://shopify/Metaobject/96864370903",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "NVIDIA® GeForce® RTX 2080"
  },
  {
    "id": "gid://shopify/Metaobject/96872628439",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD RX 6800/6800XT/6900XT Reference"
  },
  {
    "id": "gid://shopify/Metaobject/96874201303",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Gigabyte AORUS RTX 3080/3090 Aorus Master/Xtreme"
  },
  {
    "id": "gid://shopify/Metaobject/96879411415",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ROG Strix and ASUS TUF RTX 4080"
  },
  {
    "id": "gid://shopify/Metaobject/96880591063",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS TUF/STRIX 4090"
  },
  {
    "id": "gid://shopify/Metaobject/96868925655",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD 5XXX"
  },
  {
    "id": "gid://shopify/Metaobject/96871022807",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD Radeon RX 480"
  },
  {
    "id": "gid://shopify/Metaobject/96873709783",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "GeForce RTX 3090 Founders Edition"
  },
  {
    "id": "gid://shopify/Metaobject/96860078295",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "980 GTX"
  },
  {
    "id": "gid://shopify/Metaobject/96871710935",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD Radeon 5700 XT"
  },
  {
    "id": "gid://shopify/Metaobject/96874135767",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS® ROG Strix RTX 3080 and 3090"
  },
  {
    "id": "gid://shopify/Metaobject/96878297303",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD® Radeon RX 7900 XTX "
  },
  {
    "id": "gid://shopify/Metaobject/96878330071",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASRock Radeon RX 7900 XTX Series"
  },
  {
    "id": "gid://shopify/Metaobject/96879214807",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Nvidia Founders Edition RTX 4080 "
  },
  {
    "id": "gid://shopify/Metaobject/96879968471",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS TUF and ROG Strix RTX 4090"
  },
  {
    "id": "gid://shopify/Metaobject/96869089495",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD 6XXX"
  },
  {
    "id": "gid://shopify/Metaobject/96858439895",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "680 GTX"
  },
  {
    "id": "gid://shopify/Metaobject/96863879383",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "NVIDIA GeForce RTX 2060/2060 SUPER"
  },
  {
    "id": "gid://shopify/Metaobject/96869351639",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD R9 280X (Non Reference)"
  },
  {
    "id": "gid://shopify/Metaobject/96872530135",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD Radeon RX 6800/6900"
  },
  {
    "id": "gid://shopify/Metaobject/96874463447",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "MSI RTX 3090/3080 Gaming X Trio"
  },
  {
    "id": "gid://shopify/Metaobject/96859226327",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "770 GTX (Non Reference)"
  },
  {
    "id": "gid://shopify/Metaobject/96859652311",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Titan/GTX780/780Ti"
  },
  {
    "id": "gid://shopify/Metaobject/96868466903",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS ROG Strix GeForce RTX 2080 Ti"
  },
  {
    "id": "gid://shopify/Metaobject/96869318871",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD R9 270X (Non Reference)"
  },
  {
    "id": "gid://shopify/Metaobject/96870957271",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Various Newer Nvidia/AMD"
  },
  {
    "id": "gid://shopify/Metaobject/96870990039",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Sapphire Nitro+ Radeon RX 470"
  },
  {
    "id": "gid://shopify/Metaobject/96873349335",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS TUF Gaming GeForce RTX 3080"
  },
  {
    "id": "gid://shopify/Metaobject/96880197847",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Asus ROG RX4090 Strix/TUF"
  },
  {
    "id": "gid://shopify/Metaobject/96859750615",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "960 GTX"
  },
  {
    "id": "gid://shopify/Metaobject/96859783383",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "970 GTX"
  },
  {
    "id": "gid://shopify/Metaobject/96864534743",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS Dual Evo 2070/2070 Super/2080/2080 Super"
  },
  {
    "id": "gid://shopify/Metaobject/96867647703",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "NVIDIA® GeForce® RTX 2080 Ti"
  },
  {
    "id": "gid://shopify/Metaobject/96869974231",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD R9 290X Lightning"
  },
  {
    "id": "gid://shopify/Metaobject/96873513175",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS® ROG Strix RTX 3070/3080/3090"
  },
  {
    "id": "gid://shopify/Metaobject/96874299607",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": " ASUS RTX 3090/3080 ROG Strix"
  },
  {
    "id": "gid://shopify/Metaobject/96876527831",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "EVGA GeForce RTX 3090 FTW3 24GB Ultra Gaming"
  },
  {
    "id": "gid://shopify/Metaobject/96879706327",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "MSI RTX 4080 16GB SUPRIM X"
  },
  {
    "id": "gid://shopify/Metaobject/96879837399",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Nvidia Geforce RTX 4090 Reference Design"
  },
  {
    "id": "gid://shopify/Metaobject/96880918743",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "NVIDIA RTX 50XX"
  },
  {
    "id": "gid://shopify/Metaobject/96859193559",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "770 GTX"
  },
  {
    "id": "gid://shopify/Metaobject/96859455703",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Titan/GTX780"
  },
  {
    "id": "gid://shopify/Metaobject/96859816151",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "970 GTX (Non Reference)"
  },
  {
    "id": "gid://shopify/Metaobject/96860897495",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Titan-X/GTX 980 Ti"
  },
  {
    "id": "gid://shopify/Metaobject/96861421783",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Geforce GTX 1060"
  },
  {
    "id": "gid://shopify/Metaobject/96861716695",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "GeForce GTX 1070 Ti"
  },
  {
    "id": "gid://shopify/Metaobject/96862666967",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "GeForce GTX 1080 Galaxy"
  },
  {
    "id": "gid://shopify/Metaobject/96863092951",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "GTX 1080 Ti"
  },
  {
    "id": "gid://shopify/Metaobject/96864075991",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "NVIDIA GeForce RTX 2070/2070 SUPER"
  },
  {
    "id": "gid://shopify/Metaobject/96865714391",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "MSI Gaming X Trio RTX 2080"
  },
  {
    "id": "gid://shopify/Metaobject/96868434135",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "MSI Gaming X Trio RTX 2080 Ti"
  },
  {
    "id": "gid://shopify/Metaobject/96869548247",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD R9 290X"
  },
  {
    "id": "gid://shopify/Metaobject/96870236375",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD R9 Fury X"
  },
  {
    "id": "gid://shopify/Metaobject/96872071383",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS ROG Strix Radeon RX 5700 XT"
  },
  {
    "id": "gid://shopify/Metaobject/96873414871",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS TUF Gaming GeForce RTX 3080/3090"
  },
  {
    "id": "gid://shopify/Metaobject/96873611479",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "GeForce RTX 3070 Founders Edition"
  },
  {
    "id": "gid://shopify/Metaobject/96873742551",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "GeForce RTX 3080 Founders Edition"
  },
  {
    "id": "gid://shopify/Metaobject/96874397911",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS ROG Strix GeForce RTX 3090"
  },
  {
    "id": "gid://shopify/Metaobject/96874430679",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "MSI RTX 3090 Ventus "
  },
  {
    "id": "gid://shopify/Metaobject/96874496215",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": " MSI RTX 3090/3080 Ventus"
  },
  {
    "id": "gid://shopify/Metaobject/96874561751",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "MSI RTX 3090 Gaming Trio "
  },
  {
    "id": "gid://shopify/Metaobject/96874627287",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "MSI RTX 3080 Gaming Trio "
  },
  {
    "id": "gid://shopify/Metaobject/96875184343",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "EVGA GeForce RTX 3070 XC3 ULTRA GAMING"
  },
  {
    "id": "gid://shopify/Metaobject/96875249879",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS ROG Strix NVIDIA GeForce RTX 3070 DirectX 12"
  },
  {
    "id": "gid://shopify/Metaobject/96876396759",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Nvidia Geforce RTX 3080/3090 Partner Reference Layout"
  },
  {
    "id": "gid://shopify/Metaobject/96876691671",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "GALAX/GAINWARD 3090"
  },
  {
    "id": "gid://shopify/Metaobject/96876953815",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Colorful 3090 Advanced OC "
  },
  {
    "id": "gid://shopify/Metaobject/96877838551",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "EVGA GeForce RTX 3090 Ti FTW3"
  },
  {
    "id": "gid://shopify/Metaobject/96877871319",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": " NVIDIA GeForce RTX 3090 Ti FE"
  },
  {
    "id": "gid://shopify/Metaobject/96877904087",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS TUF RTX 3090 Ti"
  },
  {
    "id": "gid://shopify/Metaobject/96878231767",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": " Radeon RX 7XXX"
  },
  {
    "id": "gid://shopify/Metaobject/96878493911",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Sapphire Nitro+,Vapor-X,Pulse Radeon RX 7900 XT"
  },
  {
    "id": "gid://shopify/Metaobject/96878985431",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "NVIDIA RTX™ A6000"
  },
  {
    "id": "gid://shopify/Metaobject/96880001239",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Gigabyte Aorus RTX 4090 Master/GAMING OC"
  },
  {
    "id": "gid://shopify/Metaobject/96880689367",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Gigabyte AORUS GeForce RTX 4090 Master, 4090 Gaming OC"
  },
  {
    "id": "gid://shopify/Metaobject/96858276055",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "Nvidia 460/560Ti"
  },
  {
    "id": "gid://shopify/Metaobject/96859160791",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "760 GTX (Non Reference)"
  },
  {
    "id": "gid://shopify/Metaobject/96860012759",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "MSI 970 GTX TF5"
  },
  {
    "id": "gid://shopify/Metaobject/96860111063",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "GigaGigabyte 980 GTX WF3byte 980 GTX WF3"
  },
  {
    "id": "gid://shopify/Metaobject/96860307671",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "980 GTX (Non Reference)"
  },
  {
    "id": "gid://shopify/Metaobject/96861290711",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "NVIDIA Titan V"
  },
  {
    "id": "gid://shopify/Metaobject/96861683927",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS Turbo GeForce® GTX 1070 Ti"
  },
  {
    "id": "gid://shopify/Metaobject/96862896343",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "GIGABYTE® GeForce GTX 1080 G1"
  },
  {
    "id": "gid://shopify/Metaobject/96864403671",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "ASUS Dual GeForce RTX 2080 OC"
  },
  {
    "id": "gid://shopify/Metaobject/96869449943",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD R9 280X"
  },
  {
    "id": "gid://shopify/Metaobject/96869515479",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD R9 285X"
  },
  {
    "id": "gid://shopify/Metaobject/96870400215",
    "url": "",
    "altText": "",
    "width": 0,
    "height": 0,
    "value": "AMD® Radeon® Vega"
  }
];